import { ComponentType, createContext, useState } from "react";
import { StationManagementDetails } from "../types";

export const StationDetailsContext = createContext<[StationManagementDetails | null, React.Dispatch<React.SetStateAction<StationManagementDetails | null>>] | null>(null)

interface ChildrenProps {
    children: React.ReactNode;
}

export const StationDetailsProvider: ComponentType<ChildrenProps> = ({ children }) => {
    const detailsState = useState<StationManagementDetails | null>(null);

    return (
        <StationDetailsContext.Provider value={detailsState}>
            {children}
        </StationDetailsContext.Provider>
    )
}